module.exports = __webpack_public_path__ + "media/images/flags/32/Mozambique-0a2b6829f00dfa42a6540db83ca58d47.png";